(function () {
  'use strict';
  function initAll() {
    document.querySelectorAll('.size-guide-root').forEach(function (root) {
      if (root.dataset.sgInit) return;
      root.dataset.sgInit = '1';
      var trigger = root.querySelector('.size-guide__trigger');
      var drawer = root.querySelector('.size-guide-drawer');
      var overlay = root.querySelector('.size-guide-overlay');
      if (!trigger || !drawer || !overlay) return;

      // Move drawer + overlay to <body>. Dawn's scroll/slide-in animations put CSS
      // transforms on ancestor sections, and a transformed ancestor becomes the
      // containing block for position:fixed - which made the drawer open inside
      // the product column instead of sliding over the screen from the edge.
      // Body-level nodes are always fixed to the real viewport.
      var key = drawer.id || 'size-guide';
      document.querySelectorAll('body > [data-sg-moved="' + key + '"]').forEach(function (el) { el.remove(); });
      drawer.setAttribute('data-sg-moved', key);
      overlay.setAttribute('data-sg-moved', key);
      document.body.appendChild(overlay);
      document.body.appendChild(drawer);

      function open() { drawer.classList.add('is-open'); overlay.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; drawer.focus(); }
      function close() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
      trigger.addEventListener('click', open);
      overlay.addEventListener('click', close);
      var closeBtn = drawer.querySelector('.size-guide-drawer__close');
      if (closeBtn) closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      drawer.querySelectorAll('.size-guide__unit-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.getAttribute('data-unit');
          drawer.querySelectorAll('.size-guide__unit-option').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          drawer.querySelectorAll('.size-guide__circumference').forEach(function (cell) { cell.textContent = cell.getAttribute('data-' + unit); });
        });
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
